import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiHome, FiUser, FiMic, FiSettings } from 'react-icons/fi';
import { UserContext } from '../App';
import { hasRoleEntitlement, ROLE_ARTIST } from '../utils/roles';

export default function MobileNavTabs() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const appUser = useContext(UserContext);
  const tabs = [
    { label: 'Home', to: '/home', icon: FiHome },
    { label: 'Fan', to: '/fan', icon: FiUser },
    ...(hasRoleEntitlement(appUser, ROLE_ARTIST) ? [{ label: 'Creator', to: '/creator', icon: FiMic }] : []),
    { label: 'Settings', to: '/fan/settings', icon: FiSettings },
  ];

  const isActive = (to) => {
    if (to === '/creator') return pathname.startsWith('/creator');
    if (to === '/fan') return pathname === '/fan';
    if (to === '/fan/settings') return pathname.startsWith('/fan/settings');
    return pathname.startsWith(to);
  };

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, background: 'rgba(255,255,255,0.96)', padding: '2px 10px 2px', borderRadius: 18, boxShadow: '0 16px 32px rgba(15,23,42,0.1)' }}>
      {tabs.map(({ label, to, icon: Icon }) => {
        const active = isActive(to);
        const accent = '#0ea5e9';
        return (
          <button
            key={label}
            onClick={() => navigate(to)}
            aria-current={active ? 'page' : undefined}
            style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3, minWidth: 56, padding: '4px 4px 6px', background: 'transparent', border: 'none', color: active ? accent : '#475569', fontSize: 10.5, fontWeight: active ? 600 : 500, cursor: 'pointer' }}
          >
            <Icon size={14} color={active ? accent : '#94a3b8'} />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
